module.exports = __webpack_public_path__ + "img/6f7b8631f2732f40a92e7d2fd7b29bb3.png";